import { useTranslation } from 'react-i18next';

import { FieldComponent, Toggle } from 'libs/form';
import { InputWithHelp, Help } from 'libs/ui';
import { ZoneInputBox } from '../styled';
import { Input, Inputs, Interface, Wrapper, Block, Title, ZoneLabel } from './hourly-day-night-tariffication.styled';

export const HourlyDayNightTariffication = (props) => {
  const { color, display, disabled } = props;
  const withFreeperiod = true;
  const withBoundaries = true;

  const { t } = useTranslation();

  return (
    <Interface color={color} style={{ display: display ? 'block' : 'none' }}>
      <Wrapper>
        <Block>
          <Title>{t('form.Дневной период')}</Title>
          <Inputs>
            <Input>
              <ZoneLabel>{t('form.Стоимость часа')}</ZoneLabel>
              <ZoneInputBox wide>
                <FieldComponent disabled={disabled} name="day_hour_cost" title={t('form.Стоимость часа')} type="text" naturalNumber withZero maxValueLength={8} />
              </ZoneInputBox>
            </Input>
            <Input>
              <ZoneLabel>{t('form.Начало периода')}</ZoneLabel>
              <ZoneInputBox wide>
                <FieldComponent disabled={disabled} name="day_start_time" title={t('form.Начало периода')} type="time" maxValueLength={8} />
              </ZoneInputBox>
            </Input>
            <Input>
              <ZoneLabel>{t('form.Максимальная стоимость за период')}</ZoneLabel>
              <ZoneInputBox wide>
                <FieldComponent
                  disabled={disabled}
                  name="day_amount_limit"
                  title={t('form.Максимальная стоимость за период')}
                  type="text"
                  naturalNumber
                  withZero
                  maxValueLength={8}
                />
              </ZoneInputBox>
            </Input>
          </Inputs>
          <Inputs>
            <Input>
              <ZoneLabel>{t('form.Бесплатное время')}</ZoneLabel>
              <ZoneInputBox wide>
                <FieldComponent
                  type="text"
                  name="day_free_interval"
                  title={t('form.Бесплатное время')}
                  naturalNumber
                  withZero
                  maxValueLength={5}
                  disabled={disabled}
                  mask={{ suffix: t('form.мин') }}
                />
              </ZoneInputBox>
            </Input>
            <InputWithHelp style={{ margin: '40px 0 0' }}>
              <Toggle className="black" label={t('tariffs.Бесплатное время при каждом начале периода')} name="day_free_interval_loop" type="toggle" disabled={disabled} />
              <Help className="white" info={t('tariffs.Бесплатное время при каждом начале периода помощь')} />
            </InputWithHelp>
          </Inputs>
        </Block>
        <Block>
          <Title>{t('form.Ночной период')}</Title>
          <Inputs>
            <Input>
              <ZoneLabel>{t('form.Стоимость часа')}</ZoneLabel>
              <ZoneInputBox wide>
                <FieldComponent disabled={disabled} name="night_hour_cost" title={t('form.Стоимость часа')} type="text" naturalNumber withZero maxValueLength={8} />
              </ZoneInputBox>
            </Input>
            <Input>
              <ZoneLabel>{t('form.Начало периода')}</ZoneLabel>
              <ZoneInputBox wide>
                <FieldComponent disabled={disabled} name="night_start_time" title={t('form.Начало периода')} type="time" maxValueLength={8} />
              </ZoneInputBox>
            </Input>
            <Input>
              <ZoneLabel>{t('form.Максимальная стоимость за период')}</ZoneLabel>
              <ZoneInputBox wide>
                <FieldComponent
                  disabled={disabled}
                  name="night_amount_limit"
                  title={t('form.Максимальная стоимость за период')}
                  type="text"
                  naturalNumber
                  withZero
                  maxValueLength={8}
                />
              </ZoneInputBox>
            </Input>
          </Inputs>
          <Inputs>
            <Input>
              <ZoneLabel>{t('form.Бесплатное время')}</ZoneLabel>
              <ZoneInputBox wide>
                <FieldComponent
                  type="text"
                  name="night_free_interval"
                  title={t('form.Бесплатное время')}
                  naturalNumber
                  withZero
                  maxValueLength={5}
                  disabled={disabled}
                  mask={{ suffix: t('form.мин') }}
                />
              </ZoneInputBox>
            </Input>
            <InputWithHelp style={{ margin: '40px 0 0' }}>
              <Toggle className="black" label={t('tariffs.Бесплатное время при каждом начале периода')} name="night_free_interval_loop" type="toggle" disabled={disabled} />
              <Help className="white" info={t('tariffs.Бесплатное время при каждом начале периода помощь')} />
            </InputWithHelp>
          </Inputs>
        </Block>
        <Block>
          {withBoundaries && (
            <InputWithHelp>
              <Toggle className="black" label={t('form.Тарифицировать на границе дня и ночи')} name="use_boundaries" type="toggle" disabled={disabled} />
              <Help className="white" info={t('tariffs.Тарифицировать на границе дня и ночи помощь')} />
            </InputWithHelp>
          )}
          {withFreeperiod && (
            <>
              <InputWithHelp>
                <Toggle className="black" label={t('form.Тарификация бесплатного времени')} name="use_freeperiod" type="toggle" disabled={disabled} />
                <Help className="white" info={t('tariffs.Тарификация бесплатного времени помощь')} />
              </InputWithHelp>
              <InputWithHelp>
                <Input>
                  <ZoneLabel>{t('form.Бесплатное время')}</ZoneLabel>
                  <ZoneInputBox wide>
                    <FieldComponent
                      type="text"
                      name="free_interval"
                      title={t('form.Бесплатное время')}
                      naturalNumber
                      withZero
                      maxValueLength={5}
                      disabled={disabled}
                      mask={{ suffix: t('form.мин') }}
                    />
                  </ZoneInputBox>
                </Input>
                <Help
                  style={{
                    marginTop: '40px',
                  }}
                  className="white"
                  info={t('tariffs.Бесплатное время помощь')}
                />
              </InputWithHelp>
            </>
          )}
        </Block>
      </Wrapper>
    </Interface>
  );
};
